import Slider from "react-slick";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {Helmet} from 'react-helmet';
import HomeSlider from "../homeslider";
import PopularFlights from "../PopularFlights";

import AboutUs from "../AboutUs";
import Faqs from "../Faqs";
import Newsletter from "../Newsletter";
import PopularFlightsRoutes from "../PopularFlightsRoutes";
import PopularHotels from "../Hotels/Component/PopularHotels";
import BookTickets from "../BookTickets";
import FlightDestinations from "../FlightDestinations";
import PopularAirlines from "../PopularAirlines";
import FlightsFrom from "../FlightsFrom";
import FlightsWidgit from "../FlightsWidgit";
import CheapFlights from "../CheapFlights";
import Badge from "../Badge";

function App1() {
  return (
   <>


    <Helmet>     
<title>Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com</title>
<meta name="description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time"/>
<meta name="keywords" content="Cheapflightsprices, Cheap Flights Prices,cheap flight booking, cheap flight fares,flight booking offer,Lufthansa Airlines Flights, Lufthansa Airlines Tickets, Lufthansa Airlines Reservations"/>
<meta property="og:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta property="og:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<meta property="og:site_name" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:title" content="Cheap Flights Prices, Lowest Airfare and offers | cheapflightsprices.com" />
<meta name="twitter:description" content="Find Cheap Flight Tickets at cheapflightsprices.com. Also Get best deals online for your summer vacation. Book your flight tickets in advance to avail the best discounts. Hurry up! Offer is valid for limited time" />
<link rel="canonical" href="https://cheapflightsprices.com/airlines/lufthansa.html" />
</Helmet>

   <section id="banner_section">
    <div className="hero-container" data-aos="zoom-in" data-aos-delay="100">
      <h1 className="mb-2 pb-0">Lufthansa</h1>
      <h2>Cheap Flights Prices Booking Start @ $24</h2>
      <FlightsWidgit/>
      
    </div>
  </section>
<Badge/>


    <main id="main">
    <PopularFlights/>
    <FlightDestinations/>
    <PopularAirlines/>
    <PopularFlightsRoutes />
    <PopularHotels />
    <FlightsFrom/>
    <section id="Cheapflights" className="section-with-bg">
    <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2><strong>Lufthansa</strong></h2>
          <p></p>
        </div>
        <div className="designcontainer">
         Lufthansa, founded in 1953, is one of the world's leading airlines, renowned for its exceptional service and commitment to quality. With a rich history, an extensive global network, and a strong focus on safety and sustainability, Lufthansa continues to be a preferred choice for travelers across the globe.
<h2>Introduction</h2>
Lufthansa holds a prominent position in the aviation industry, offering a wide range of services to passengers and cargo customers alike. From its humble beginnings to its present-day success, Lufthansa has continuously evolved to meet the ever-changing demands of the aviation market.
<h2>History of Lufthansa</h2>
<h3>Founding and early years</h3>
Lufthansa traces its roots back to 1953 when it was established as the national airline of Germany. Initially, the airline operated a limited number of domestic flights, connecting major cities within the country.
<h3>Expansion and growth</h3>
As the demand for air travel grew, Lufthansa expanded its operations to international destinations. The airline quickly gained a reputation for its punctuality, reliability, and excellent customer service. Lufthansa's dedication to passenger satisfaction propelled its growth, and it soon became a leading player in the global aviation industry.
<h3>Impact of World War II</h3>
Like many airlines during World War II, Lufthansa faced significant challenges due to the conflict. Operations were severely affected, and the airline had to rebuild its infrastructure after the war. Despite these setbacks, Lufthansa managed to regain its position and emerge as a key player in the post-war era.
<h3>Post-war recovery and development</h3>
In the post-war years, Lufthansa focused on expanding its route network and modernizing its fleet. The airline embraced technological advancements, introducing jet aircraft to provide faster and more comfortable travel experiences for passengers. Lufthansa's commitment to innovation and its unwavering dedication to safety helped it establish a strong foothold in the global aviation market.
        </div>
      </div>
    </section>
    <Faqs/>
    <Newsletter/>
    
      </main>
  
    </>
  );
}
export default App1;
